import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
const IMAGES = {
  packshot: 'https://cdn.magicpatterns.com/uploads/ckEK2fDVMho2aEzwy1jUxB/imgi_30_1746975295-SnoreStop™_(1).png'
};
export function WhyFivePackSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-blue-50 overflow-hidden" data-id="element-545">
      <Container data-id="element-546">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-547">
          {/* Left Content */}
          <div className="order-2 lg:order-1" data-id="element-548">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-549">
              Why Most People Choose the 5-Pack
            </h2>

            <p className="text-xl text-gray-600 mb-8" data-id="element-550">
              Because snoring doesn't ruin one night… It ruins weeks. Months.
              Years. Backups mean you're always prepared:
            </p>

            <div className="space-y-4 mb-10" data-id="element-551">
              {['One at home', 'One for travel', 'One for your partner', 'Extras if lost or replaced', 'Share with family who snores too'].map((reason, index) => <div key={index} className="flex items-center p-4 bg-white rounded-lg shadow-sm border border-blue-100" data-id="element-552">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mr-4" data-id="element-553">
                    <Check className="w-5 h-5 text-green-600" data-id="element-554" />
                  </div>
                  <span className="text-gray-800 font-medium text-lg" data-id="element-555">
                    {reason}
                  </span>
                </div>)}
            </div>

            <Button onClick={scrollToPricing} variant="primary" size="lg" className="shadow-xl shadow-blue-900/20 w-full sm:w-auto" data-id="element-556">
              Claim Your Bundle Now →
            </Button>
          </div>

          {/* Right Visual */}
          <div className="order-1 lg:order-2 flex justify-center" data-id="element-557">
            <div className="relative w-full max-w-md h-64 flex items-center justify-center" data-id="element-558">
              <div className="absolute inset-0 bg-white rounded-full filter blur-3xl opacity-60" data-id="element-559"></div>

              {/* 5 Overlapping Packshots */}
              <div className="relative flex justify-center -space-x-12 z-10" data-id="element-560">
                {[1, 2, 3, 4, 5].map(i => <div key={i} className="transform transition-transform hover:-translate-y-4 duration-300" style={{
                zIndex: i
              }} data-id="element-561">
                    <img src={IMAGES.packshot} alt={`Pack ${i}`} className="w-32 md:w-40 drop-shadow-xl" data-id="element-562" />
                  </div>)}
              </div>

              <div className="absolute -bottom-4 right-0 bg-white px-4 py-2 rounded-lg shadow-lg border border-gray-100 rotate-3 animate-pulse" data-id="element-563">
                <span className="font-bold text-blue-600" data-id="element-564">BEST VALUE</span>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}